'use client'

import { Ajax } from '@newrelic/browser-agent/features/ajax'
import { JSErrors } from '@newrelic/browser-agent/features/jserrors'
import { Metrics } from '@newrelic/browser-agent/features/metrics'
import { PageViewTiming } from '@newrelic/browser-agent/features/page_view_timing'
import { SoftNav } from '@newrelic/browser-agent/features/soft_navigations'
import { Agent } from '@newrelic/browser-agent/loaders/agent'
import {
  setNewRelicBrowserAgent,
  shouldIgnoreBrowserError,
} from './new-relic-browser'

let browserAgent
let initializationAttempted = false

export function initializeNewRelicBrowser() {
  if (
    browserAgent ||
    initializationAttempted ||
    typeof window === 'undefined'
  ) {
    return browserAgent || null
  }

  initializationAttempted = true

  const licenseKey = process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_LICENSE_KEY
  const applicationID = process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_APPLICATION_ID
  const accountID = process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_ACCOUNT_ID
  const trustKey = process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_TRUST_KEY
  const agentID = process.env.NEXT_PUBLIC_NEW_RELIC_BROWSER_AGENT_ID

  if (!licenseKey || !applicationID || !accountID || !trustKey || !agentID) {
    return null
  }

  try {
    browserAgent = new Agent({
      info: {
        applicationID,
        licenseKey,
        sa: 1,
      },
      loader_config: {
        accountID,
        agentID,
        applicationID,
        licenseKey,
        trustKey,
      },
      init: {
        ajax: {
          capture_payloads: 'none',
          enabled: true,
        },
        distributed_tracing: {
          enabled: true,
          exclude_newrelic_header: true,
          cors_use_newrelic_header: false,
          cors_use_tracecontext_headers: true,
        },
        jserrors: { enabled: true },
        logging: { enabled: false },
        metrics: { enabled: true },
        page_view_timing: { enabled: true },
        session_replay: { enabled: false },
        session_trace: { enabled: false },
        soft_navigations: { enabled: true },
      },
      features: [Ajax, JSErrors, Metrics, PageViewTiming, SoftNav],
    })

    browserAgent.setErrorHandler((error) => shouldIgnoreBrowserError(error))

    const release = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA
    if (release) browserAgent.setApplicationVersion(release)

    setNewRelicBrowserAgent(browserAgent)
    return browserAgent
  } catch (error) {
    console.error('Failed to initialize New Relic Browser', error)
    return null
  }
}
